import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=0c42f337&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=ts"
export * from "./GroupTable.vue?vue&type=script&lang=ts"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=0c42f337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42f337",
  null
  
)

export default component.exports